export const indiaFilterToUtc = value => value ? new Date(value + "+05:30").toISOString() : "";
export function formatIndiaTime(value) {
  if (!value) return "—";
  const raw = String(value);
  const iso = raw.replace(" ", "T");
  const date = new Date(/(?:Z|[+-]\d{2}:\d{2})$/i.test(iso) ? iso : iso + "Z");
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true
  }).format(date) + " IST";
}
